// Free-trial presets for the Ontario Provincial Report Card Gr. 7–8 (pvrc7to8_2023_09).
// Each preset is a complete flat object matching every key in formSchema.
// Grade values: "A" | "B+" | "B" | "C+" | "C" | "D+" | "D" | "R" | "IE" | ""
// Median values: same letter scale (optional, can be empty)
// Plan values: "ESLELD" | "IEP" | "NA" | "Core" | "Immersion" | "Extended" | "French" | ""
// Learning skill values: "E" | "G" | "S" | "N" | ""

export const PRESETS = [
  {
    label: "Example: Mei Chen",
    data: {
      date: "2024-11-15",
      studentName: "Mei Chen",
      oen: "222333444",
      grade: "7",
      gradeInSeptember: "7",
      teacher: "Ms. Rivera",
      board: "Toronto District School Board",
      school: "Maple Leaf Public School",
      address1: "100 Main Street",
      address2: "Toronto, ON M4B 1A1",
      principal: "Mr. Johnson",
      telephone: "416-555-0100",
      daysAbsent: "2",
      totalDaysAbsent: "3",
      timesLate: "0",
      totalTimesLate: "0",
      responsibility1: "G",
      organization1: "E",
      independentWork1: "G",
      collaboration1: "G",
      initiative1: "G",
      selfRegulation1: "G",
      responsibility2: "G",
      organization2: "G",
      independentWork2: "G",
      collaboration2: "E",
      initiative2: "G",
      selfRegulation2: "G",
      strengthsNextStepsLSWH:
        "Mei demonstrates strong organizational skills and collaborates well with classmates. Next steps: continue to develop confidence in group discussions.",
      languagePlan: "",
      languageGrade1: "B",
      languageMedian1: "",
      languageGrade2: "B+",
      languageMedian2: "",
      languageComments:
        "Mei is making consistent progress in reading comprehension and written expression.",
      nativeLanguage: "",
      nativeLanguagePlan: "",
      nativeLanguageGrade1: "",
      nativeLanguageMedian1: "",
      nativeLanguageGrade2: "",
      nativeLanguageMedian2: "",
      nativeLanguageComments: "",
      frenchPlan: "Core",
      frenchListeningPlan: "",
      frenchListeningGrade1: "B",
      frenchListeningMedian1: "",
      frenchListeningGrade2: "B",
      frenchListeningMedian2: "",
      frenchSpeakingPlan: "",
      frenchSpeakingGrade1: "B",
      frenchSpeakingMedian1: "",
      frenchSpeakingGrade2: "B+",
      frenchSpeakingMedian2: "",
      frenchReadingPlan: "",
      frenchReadingGrade1: "B",
      frenchReadingMedian1: "",
      frenchReadingGrade2: "B",
      frenchReadingMedian2: "",
      frenchWritingPlan: "",
      frenchWritingGrade1: "B",
      frenchWritingMedian1: "",
      frenchWritingGrade2: "B",
      frenchWritingMedian2: "",
      frenchComments:
        "Mei participates actively in French and is developing her oral communication skills.",
      mathematicsPlan: "",
      mathematicsGrade1: "B+",
      mathematicsMedian1: "",
      mathematicsGrade2: "A",
      mathematicsMedian2: "",
      mathematicsComments: "Mei shows strong number sense and excellent problem-solving skills.",
      scienceAndTechnologyPlan: "",
      scienceAndTechnologyGrade1: "B",
      scienceAndTechnologyMedian1: "",
      scienceAndTechnologyGrade2: "B+",
      scienceAndTechnologyMedian2: "",
      scienceAndTechnologyComments: "",
      historyPlan: "",
      historyGrade1: "B",
      historyMedian1: "",
      historyGrade2: "B",
      historyMedian2: "",
      historyComments: "",
      geographyPlan: "",
      geographyGrade1: "B+",
      geographyMedian1: "",
      geographyGrade2: "B+",
      geographyMedian2: "",
      geographyComments: "",
      healthEducationPlan: "",
      healthEducationGrade1: "B",
      healthEducationMedian1: "",
      healthEducationGrade2: "B",
      healthEducationMedian2: "",
      physicalEducationPlan: "",
      physicalEducationGrade1: "B+",
      physicalEducationMedian1: "",
      physicalEducationGrade2: "B+",
      physicalEducationMedian2: "",
      healthAndPhysicalEducationComments: "",
      artsHeader: "The Arts",
      arts1: "Visual Arts",
      arts1Plan: "",
      arts1Grade1: "B",
      arts1Median1: "",
      arts1Grade2: "B+",
      arts1Median2: "",
      arts2: "Music",
      arts2Plan: "",
      arts2Grade1: "B",
      arts2Median1: "",
      arts2Grade2: "B",
      arts2Median2: "",
      arts3: "Drama",
      arts3Plan: "",
      arts3Grade1: "B",
      arts3Median1: "",
      arts3Grade2: "B",
      arts3Median2: "",
      arts4: "",
      arts4Plan: "",
      arts4Grade1: "",
      arts4Median1: "",
      arts4Grade2: "",
      arts4Median2: "",
      artsComments: "",
      optionalStudies: "",
      optionalStudiesPlan: "",
      optionalStudiesGrade1: "",
      optionalStudiesGrade2: "",
      optionalStudiesComments: "",
    },
  },
  {
    label: "Example: Luca Rossi",
    data: {
      date: "2024-11-15",
      studentName: "Luca Rossi",
      oen: "555666777",
      grade: "8",
      gradeInSeptember: "8",
      teacher: "Mr. Williams",
      board: "Toronto District School Board",
      school: "Maple Leaf Public School",
      address1: "100 Main Street",
      address2: "Toronto, ON M4B 1A1",
      principal: "Mr. Johnson",
      telephone: "416-555-0100",
      daysAbsent: "5",
      totalDaysAbsent: "8",
      timesLate: "2",
      totalTimesLate: "3",
      responsibility1: "G",
      organization1: "S",
      independentWork1: "G",
      collaboration1: "G",
      initiative1: "G",
      selfRegulation1: "S",
      responsibility2: "G",
      organization2: "G",
      independentWork2: "G",
      collaboration2: "G",
      initiative2: "G",
      selfRegulation2: "G",
      strengthsNextStepsLSWH:
        "Luca is an engaged learner who contributes thoughtfully to class discussions. Next steps: develop more consistent organizational habits for long-term assignments.",
      languagePlan: "IEP",
      languageGrade1: "C+",
      languageMedian1: "",
      languageGrade2: "B",
      languageMedian2: "",
      languageComments:
        "Luca is making meaningful progress with the support of his IEP accommodations.",
      nativeLanguage: "",
      nativeLanguagePlan: "",
      nativeLanguageGrade1: "",
      nativeLanguageMedian1: "",
      nativeLanguageGrade2: "",
      nativeLanguageMedian2: "",
      nativeLanguageComments: "",
      frenchPlan: "Core",
      frenchListeningPlan: "",
      frenchListeningGrade1: "B",
      frenchListeningMedian1: "",
      frenchListeningGrade2: "B",
      frenchListeningMedian2: "",
      frenchSpeakingPlan: "",
      frenchSpeakingGrade1: "B",
      frenchSpeakingMedian1: "",
      frenchSpeakingGrade2: "B",
      frenchSpeakingMedian2: "",
      frenchReadingPlan: "",
      frenchReadingGrade1: "C+",
      frenchReadingMedian1: "",
      frenchReadingGrade2: "B",
      frenchReadingMedian2: "",
      frenchWritingPlan: "",
      frenchWritingGrade1: "C+",
      frenchWritingMedian1: "",
      frenchWritingGrade2: "B",
      frenchWritingMedian2: "",
      frenchComments: "",
      mathematicsPlan: "",
      mathematicsGrade1: "A",
      mathematicsMedian1: "",
      mathematicsGrade2: "A",
      mathematicsMedian2: "",
      mathematicsComments:
        "Luca excels in mathematics, demonstrating strong analytical thinking and problem-solving.",
      scienceAndTechnologyPlan: "",
      scienceAndTechnologyGrade1: "B+",
      scienceAndTechnologyMedian1: "",
      scienceAndTechnologyGrade2: "A",
      scienceAndTechnologyMedian2: "",
      scienceAndTechnologyComments: "",
      historyPlan: "",
      historyGrade1: "B",
      historyMedian1: "",
      historyGrade2: "B+",
      historyMedian2: "",
      historyComments: "",
      geographyPlan: "",
      geographyGrade1: "B",
      geographyMedian1: "",
      geographyGrade2: "B",
      geographyMedian2: "",
      geographyComments: "",
      healthEducationPlan: "",
      healthEducationGrade1: "B",
      healthEducationMedian1: "",
      healthEducationGrade2: "B",
      healthEducationMedian2: "",
      physicalEducationPlan: "",
      physicalEducationGrade1: "B+",
      physicalEducationMedian1: "",
      physicalEducationGrade2: "B+",
      physicalEducationMedian2: "",
      healthAndPhysicalEducationComments: "",
      artsHeader: "The Arts",
      arts1: "Visual Arts",
      arts1Plan: "",
      arts1Grade1: "B",
      arts1Median1: "",
      arts1Grade2: "B",
      arts1Median2: "",
      arts2: "Music",
      arts2Plan: "",
      arts2Grade1: "C+",
      arts2Median1: "",
      arts2Grade2: "B",
      arts2Median2: "",
      arts3: "",
      arts3Plan: "",
      arts3Grade1: "",
      arts3Median1: "",
      arts3Grade2: "",
      arts3Median2: "",
      arts4: "",
      arts4Plan: "",
      arts4Grade1: "",
      arts4Median1: "",
      arts4Grade2: "",
      arts4Median2: "",
      artsComments: "",
      optionalStudies: "",
      optionalStudiesPlan: "",
      optionalStudiesGrade1: "",
      optionalStudiesGrade2: "",
      optionalStudiesComments: "",
    },
  },
  {
    label: "Example: Aisha Rahman",
    data: {
      date: "2024-11-15",
      studentName: "Aisha Rahman",
      oen: "888999000",
      grade: "7",
      gradeInSeptember: "7",
      teacher: "Ms. Kim",
      board: "Toronto District School Board",
      school: "Maple Leaf Public School",
      address1: "100 Main Street",
      address2: "Toronto, ON M4B 1A1",
      principal: "Mr. Johnson",
      telephone: "416-555-0100",
      daysAbsent: "1",
      totalDaysAbsent: "1",
      timesLate: "0",
      totalTimesLate: "0",
      responsibility1: "G",
      organization1: "G",
      independentWork1: "G",
      collaboration1: "G",
      initiative1: "G",
      selfRegulation1: "G",
      responsibility2: "G",
      organization2: "G",
      independentWork2: "G",
      collaboration2: "G",
      initiative2: "G",
      selfRegulation2: "G",
      strengthsNextStepsLSWH:
        "Aisha is a dedicated student who consistently demonstrates positive learning skills. Next steps: encourage Aisha to take more initiative in asking questions.",
      languagePlan: "",
      languageGrade1: "B",
      languageMedian1: "",
      languageGrade2: "B",
      languageMedian2: "",
      languageComments: "Aisha is developing strong reading and writing skills.",
      nativeLanguage: "",
      nativeLanguagePlan: "",
      nativeLanguageGrade1: "",
      nativeLanguageMedian1: "",
      nativeLanguageGrade2: "",
      nativeLanguageMedian2: "",
      nativeLanguageComments: "",
      frenchPlan: "Core",
      frenchListeningPlan: "",
      frenchListeningGrade1: "B",
      frenchListeningMedian1: "",
      frenchListeningGrade2: "B",
      frenchListeningMedian2: "",
      frenchSpeakingPlan: "",
      frenchSpeakingGrade1: "B",
      frenchSpeakingMedian1: "",
      frenchSpeakingGrade2: "B",
      frenchSpeakingMedian2: "",
      frenchReadingPlan: "",
      frenchReadingGrade1: "B",
      frenchReadingMedian1: "",
      frenchReadingGrade2: "B",
      frenchReadingMedian2: "",
      frenchWritingPlan: "",
      frenchWritingGrade1: "B",
      frenchWritingMedian1: "",
      frenchWritingGrade2: "B",
      frenchWritingMedian2: "",
      frenchComments: "",
      mathematicsPlan: "",
      mathematicsGrade1: "B",
      mathematicsMedian1: "",
      mathematicsGrade2: "B",
      mathematicsMedian2: "",
      mathematicsComments: "",
      scienceAndTechnologyPlan: "",
      scienceAndTechnologyGrade1: "B",
      scienceAndTechnologyMedian1: "",
      scienceAndTechnologyGrade2: "B",
      scienceAndTechnologyMedian2: "",
      scienceAndTechnologyComments: "",
      historyPlan: "",
      historyGrade1: "B",
      historyMedian1: "",
      historyGrade2: "B",
      historyMedian2: "",
      historyComments: "",
      geographyPlan: "",
      geographyGrade1: "B",
      geographyMedian1: "",
      geographyGrade2: "B",
      geographyMedian2: "",
      geographyComments: "",
      healthEducationPlan: "",
      healthEducationGrade1: "B",
      healthEducationMedian1: "",
      healthEducationGrade2: "B",
      healthEducationMedian2: "",
      physicalEducationPlan: "",
      physicalEducationGrade1: "B",
      physicalEducationMedian1: "",
      physicalEducationGrade2: "B",
      physicalEducationMedian2: "",
      healthAndPhysicalEducationComments: "",
      artsHeader: "The Arts",
      arts1: "Visual Arts",
      arts1Plan: "",
      arts1Grade1: "B",
      arts1Median1: "",
      arts1Grade2: "B",
      arts1Median2: "",
      arts2: "Music",
      arts2Plan: "",
      arts2Grade1: "B",
      arts2Median1: "",
      arts2Grade2: "B",
      arts2Median2: "",
      arts3: "",
      arts3Plan: "",
      arts3Grade1: "",
      arts3Median1: "",
      arts3Grade2: "",
      arts3Median2: "",
      arts4: "",
      arts4Plan: "",
      arts4Grade1: "",
      arts4Median1: "",
      arts4Grade2: "",
      arts4Median2: "",
      artsComments: "",
      optionalStudies: "",
      optionalStudiesPlan: "",
      optionalStudiesGrade1: "",
      optionalStudiesGrade2: "",
      optionalStudiesComments: "",
    },
  },
]
